import React from 'react';
import {translations} from 'presentation/translations-new';
import {Typography} from '@mui/material';
import {AlertInfo} from '../AlertInfo';
import {LatePaymentDrawer} from '../LatePaymentDrawer';
import { LatePaymentAlertProps } from './types';

const {financialsDelayAlert} = translations['pt-br'].privateFlow.home;

export function LatePaymentAlert({dataTagId}: LatePaymentAlertProps) {
	return (
		<AlertInfo.Root severity="warning">
			<Typography component={'span'} fontSize={'0.875rem'}>
				<Typography component={'span'} fontSize={'inherit'} fontWeight={700}>
					{financialsDelayAlert.line1}
				</Typography>
				{financialsDelayAlert.line2}
			</Typography>
			<LatePaymentDrawer dataTagId={dataTagId} />
		</AlertInfo.Root>
	);
}
